import React, { useState } from "react";
import "./FaqQuestions.css";
import Dots from "../../../../assets/images/about-shape3.png";
import Triangle1 from "../../../../assets/images/signuptri1.png";
import Triangle2 from "../../../../assets/images/signuptri2.png";
import CustomDropdown from "../../../../Components/CustomDropdown/CustomDropdown";
import EyeClose from "../../../../assets/images/eye-close.png";
import { Link } from "react-router-dom";
import CustomAccordion from "../../../../Components/CustomAccordion/CustomAccordion";
import questions from "../data";
const FaqQuestions = () => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="faq__questions_section">
      <img src={Dots} alt="" className="faq__questions_dots" />
      <div className="faq__questionswrap">
        <img src={Triangle1} alt="" className="faq__questionstriangle1" />
        <img src={Triangle2} alt="" className="faq__questionstriangle2" />
        <div className="faq__questions">
          <div className="faq__questions_heading">FAQ</div>
          <div className="faq__questionscontent">
            {questions.map((item) => (
              <div className="faq__questionscontent_item">
                <CustomAccordion title={item.question} content={item.answer} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqQuestions;
